export enum ClientLineEnum {
  NATIONAL = "NATIONAL",
  FOREIGN = "FOREIGN",
}

export const getClientLineLabel = (line: ClientLineEnum): string => {
  switch (line) {
    case ClientLineEnum.NATIONAL:
      return "Nacional";
    case ClientLineEnum.FOREIGN:
      return "Extranjero";
  }
};

export const getClientLineOptions = (): { value: ClientLineEnum; label: string }[] => {
  const keys = Object.keys(ClientLineEnum).filter(
    (key: string) => typeof ClientLineEnum[key as keyof typeof ClientLineEnum] === "string",
  );
  return keys.map((val) => {
    const value = ClientLineEnum[val as keyof typeof ClientLineEnum];
    return { label: getClientLineLabel(value), value: value };
  });
};
